export default function closePostRegModalOnSubmit () {
  const postRegModal = document.getElementById('vjs-post-reg-modal')
  const submitButton = document.getElementById('vjs-post-reg-modal-submit')
  if (!submitButton || !postRegModal) return

  submitButton.addEventListener('click', () => {
    setTimeout(() => postRegModal.remove(), 200)
  })
}
